// getter，可以理解为是对store中state的一些派生状态，也可以理解为一种计算属性，
// 它像计算属性一样，返回值会根据它的依赖被缓存起来，
// 且依赖对象发生改变的时候它才会被重新计算。

// export const todoList = state => state.todoList

const getters = {
  getToken: state => state.token,
  getActiveBot: state => state.activeBot,
  getTokenExpiresAt: state => state.tokenExpiresAt,  // 添加过期时间的getter
  getUserInfo: state => ({  // 添加获取用户信息的getter
    userId: state.userId,
    username: state.username
  }),

}

export default getters
